module.exports = __webpack_public_path__ + "staticVue/img/start.d7d61fcd.png";